import { useState } from 'react';
import { Toast } from 'primereact/toast';
import { RoleList, RoleCreateDialog, RolePermissionsDialog } from '@authifi/clique-react-ui';
import { useEntityToasts } from '../hooks/useEntityToasts';

export function RolesPage() {
  const { toastRef, notifyCreated, notifySuccess, notifyError } = useEntityToasts('Access Role');
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState<number | null>(null);

  return (
    <div>
      <Toast ref={toastRef} />
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-2">Access Roles</h2>
      <p className="text-[var(--clique-fg-muted)] mb-6">
        Manage access roles and role assignments.
      </p>

      <RoleList
        onRoleSelect={(role) => setSelectedRoleId(role.id)}
        onCreateRole={() => setShowCreateDialog(true)}
      />

      <RoleCreateDialog
        visible={showCreateDialog}
        onHide={() => setShowCreateDialog(false)}
        onCreated={(role) => notifyCreated(role.name)}
      />

      {selectedRoleId !== null && (
        <RolePermissionsDialog
          visible
          onHide={() => setSelectedRoleId(null)}
          roleId={selectedRoleId}
          onDeleted={() => setSelectedRoleId(null)}
          onSuccess={notifySuccess}
          onError={notifyError}
        />
      )}
    </div>
  );
}
